export default __webpack_public_path__ + "static/media/icon-imc.0d8a9fff.svg";